import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { filter } from 'rxjs/operators';
import { PageType, TimeFilter } from 'src/app/models/enums';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { UtilityService } from 'src/app/services/util/utility.service';

@Component({
  selector: 'app-results-filter',
  templateUrl: './results-filter.component.html',
  styleUrls: ['./results-filter.component.less']
})
export class ResultsFilterComponent implements OnInit, OnChanges {

  public showResultsTimeFilter = false;
  public resultTimeFilterValue: TimeFilter = TimeFilter.None;
  public timeFilterValueEnum = TimeFilter;

  public resultsToday: Date;
  public resultsD1: Date;
  public resultsD2: Date;
  public resultsD3: Date;
  public resultsD4: Date;
  public resultsD5: Date;
  public resultsD6: Date;

  pageTypeEnum = PageType;

  @Input()
  pageType: PageType;

  @Output()
  filterValue: EventEmitter<TimeFilter> = new EventEmitter<TimeFilter>();

  isMobileView: boolean;

  constructor(
    public queryParamService: QueryParamsService,
    private utilityService: UtilityService,
    private googleAnalyticsService: GoogleAnalyticsService
    ) {
    this.isMobileView = utilityService.mobileView;
  }

  ngOnInit(): void {
    this.setResultsDays();
  }

  ngOnChanges(): void {
    if (this.pageType !== PageType.Results) {
      this.resultTimeFilterValue = TimeFilter.None;
    }
  }

  private setResultsDays() {
    this.resultsToday = new Date();
    this.resultsD1 = new Date(this.resultsToday.getTime() - (24 * 60 * 60 * 1000));
    this.resultsD2 = new Date(this.resultsToday.getTime() - (48 * 60 * 60 * 1000));
    this.resultsD3 = new Date(this.resultsToday.getTime() - (72 * 60 * 60 * 1000));
    this.resultsD4 = new Date(this.resultsToday.getTime() - (96 * 60 * 60 * 1000));
    this.resultsD5 = new Date(this.resultsToday.getTime() - (120 * 60 * 60 * 1000));
    this.resultsD6 = new Date(this.resultsToday.getTime() - (144 * 60 * 60 * 1000));
  }

  public selectResultsTimeFilter(filterValue: TimeFilter) {
    if (this.resultTimeFilterValue !== +filterValue) {
      this.resultTimeFilterValue = +filterValue;
      this.filterValue.emit(this.resultTimeFilterValue);

      if (filterValue === this.timeFilterValueEnum.ResultToday) {
        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Rezultati', '1');
      } else if (filterValue === this.timeFilterValueEnum.ResultD1) {
        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Rezultati', '2');
      } else if (filterValue === this.timeFilterValueEnum.ResultD2) {
        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Rezultati', '3');
      } else if (filterValue === this.timeFilterValueEnum.ResultD3) {
        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Rezultati', '4');
      } else if (filterValue === this.timeFilterValueEnum.ResultD4) {
        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Rezultati', '5');
      } else if (filterValue === this.timeFilterValueEnum.ResultD5) {
        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Rezultati', '6');
      } else if (filterValue === this.timeFilterValueEnum.ResultD6) {
        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Rezultati', '7');
      }
    }
  }

}
